module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-epigraph element-without-heading",
    attrs: {
      "epub:type": "epigraph",
      "id": "epigraph"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-left"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left epigraph-content"
  }, [_vm._v("“…I think this is")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left epigraph-content"
  }, [_vm._v("the prettiest world—so long as you don’t mind")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left epigraph-content"
  }, [_vm._v("a little dying, how could there be a day in your whole life")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left epigraph-content"
  }, [_vm._v("that doesn’t have its splash of happiness?”")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left epigraph-content"
  }, [_vm._v("—Mary Oliver, “The Kingfisher”")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18a0d7e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 72
// module chunks = 0